import { hostsConfig, turnToConfig } from 'init/config'
import resourceLoader from 'init/resource-loader'

// This sets the path to the server so webpack knows how to load other chunks
// (dynamically loaded modules)
// NOTE: imports cannot go above this line unless they are already part of turnto.js
const path = process.env.NODE_ENV === 'development' || process.env.testProdBuild ? '' : 'v5/widgets/ie'
__webpack_public_path__ = `${hostsConfig.protocol}://${hostsConfig.widgetsHost}/${path}`

interface IPagesConfig {
  [name: string]: {
    baseCssFilePath: string
    baseJsFilePath: string
    pageCssFilePath: string
    customCss?: string
    pageJsFilePath: { [locale: string]: string }
  }
}

function loadPage(pagesConfig: IPagesConfig) {
  const pageFilesConfig = pagesConfig[turnToConfig.pageId]
  if (!pageFilesConfig) {
    // tslint:disable-next-line:no-console
    console.warn(`TurnTo: Could not find configuration for pageId: ${turnToConfig.pageId}`)
    return
  }
  if (pageFilesConfig.pageCssFilePath) {
    resourceLoader.loadPageCss(pageFilesConfig.pageCssFilePath)
  }
  if (pageFilesConfig.customCss) {
    resourceLoader.loadCustomCss(pageFilesConfig.customCss)
  }
  resourceLoader.loadBaseJs(pageFilesConfig.baseJsFilePath)
  if (!pageFilesConfig.pageJsFilePath[turnToConfig.locale]) {
    // tslint:disable-next-line:no-console
    console.warn(`TurnTo: Could not find a page configuration for locale: ${turnToConfig.locale}`)
    return
  }
  resourceLoader.loadPageJs(pageFilesConfig.pageJsFilePath[turnToConfig.locale])
}

if (process.env.NODE_ENV === 'development') {
  // DO NOT REMOVE OR CHANGE THE loadPage LINE. The dev-pages-for-entry.js loader will replace that
  // with a pages object that is derived from the entry points listed in webpack.config.dev.js
  // loadPage({...})
}

// window.TurnTo defined in the Webpack bootstrap code.  Insertion of this definition is done
// by the json-main-template-promise-plugin
if (!window['TurnTo']) {
  window['TurnTo'] = {}
}
window['TurnTo'].loadPage = loadPage
